import { render, staticRenderFns } from "./DefaultImagePopUp.vue?vue&type=template&id=e5e59d54&scoped=true&"
import script from "./DefaultImagePopUp.vue?vue&type=script&lang=js&"
export * from "./DefaultImagePopUp.vue?vue&type=script&lang=js&"
import style0 from "./DefaultImagePopUp.vue?vue&type=style&index=0&id=e5e59d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e59d54",
  null
  
)

export default component.exports